import React from 'react'
import carousalImage from './Images/carousalTwo.jpg'
import { Link } from 'react-router-dom'
export default function Carousal() {
    return (
        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="false">

            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src={carousalImage} class="d-block w-100" alt="..." />
                    <div class="carousel-caption d-md-block mb-5">
                        <div className="mb-5">
                            <div data-aos="fade-up"      data-aos-duration="2000" style={{zIndex:30,position:'relative'}}>
                                <div className="mb-5 pb-5">
                                    <div className="mb-5 pb-5 theBox">
                                        <h1 style={{ fontSize: '4vw' }}>WELCOME</h1>
                                        <h4 style={{ fontSize: '2vw' }}>CREATING A BRIGHTER FUTURE TOGETHER</h4>
                                      <Link to="/whoweare">  <button style={{backgroundColor:'#A10302',color:'white',borderRadius:'0px'}} className="btn p-2 m-2">WHO WE ARE</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="shaderLight"></div>

            </div>

        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/carousal.jsx